<div class="vl-region">
  <div class="vl-layout vl-layout--wide">
    <div class="vl-grid vl-grid--is-stacked">
      <div class="vl-col--9-12 vl-col--1-1--xs">
        <h2 class="vl-title vl-title--h2">{{ 'LOGGED_OUT.TITLE' | translate }}</h2>

        <div class="vl-alert vl-alert--succes" role="alert">
          <div class="vl-alert__icon">
            <i class="vl-vi vl-vi-warning" aria-hidden="true"></i>
          </div>
          <div class="vl-alert__content">
            <div class="vl-alert__message">
              <div [innerHTML]="'LOGGED_OUT.INFO' | translate"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="vl-col--3-12 vl-col--3-12--m vl-col--12-12--s vl-col--1-1--xs"></div>
    </div>
  </div>
</div>
